export const AlertTypes = {
  SET_OPEN: 'SET_OPEN',
  SET_SEVERITY: 'SET_SEVERITY',
  SET_MESSAGE: 'SET_MESSAGE',
};
